module.exports = __webpack_public_path__ + "img/stu-info-regst-l.2faf584c.jpg";